import { FC } from 'react'
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { Stack } from "@mui/material";
import "./style.scss";
import BorderLessInput from '../Custom/BorderLessInput';
import moment from "moment";

interface TimePickerProps {
  formState: any
}
const CustomTimePicker: FC<TimePickerProps> = ({ formState }) => {

  const getTime = (time: string | object) => {
    return typeof (time) === "string" ? moment(time) : time;
  }

  return (
    <div className="datetimepicker-container">
      <Stack spacing={1} className="time-picker-container">
        {formState.watch(`options`)?.map((moc: any, index: number) => {

          return (
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
            >
              <div className="each-time-picker">
                {<BorderLessInput
                  color="white"
                  placeHolder='Label (Optional)'
                  value={formState.watch(`options[${index}].label`) || ''}
                  setValue={(value) => {
                    formState.setValue(`options[${index}].label`, value);
                  }}
                />}
                <TimePicker
                  className="date-range-picker"
                  ampm={false}
                  maxTime={
                    moc.rules?.maxTime ? getTime(moc.rules?.maxTime) : null
                  }
                  minTime={
                    moc.rules?.minTime ? getTime(moc.rules?.minTime) : null
                  }
                />
              </div>
            </LocalizationProvider>
          );
        })}
      </Stack>
    </div>
  );
}

export default CustomTimePicker;
